import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
class TicketStatusTicketTypeCategoryTab extends GenericListSearchTab {
    SearchType(): string {
        return "TicketTypeCategory";
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return null;
    }
    CustomFilter() {
        return null;
    }
}
export default TicketStatusTicketTypeCategoryTab;